import { render } from "./DateTimePicker.vue?vue&type=template&id=8086deec"
import script from "./DateTimePicker.vue?vue&type=script&lang=ts"
export * from "./DateTimePicker.vue?vue&type=script&lang=ts"
script.render = render

export default script